// import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('app')

export default function initApp () {
  const { setMenusList } = mapActions(['setMenusList'])
  setMenusList.call(this, []).then(r => {}).catch(e => {})
  // Vue.ls.set('Token', 'A2D3F3LXD3220FC9SFA923', 7 * 24 * 60 * 60 * 1000)
}
